(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    class MegaMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
  this.promo = this.querySelector('.mega-menu__promo');
  this.promoImage = this.promo.querySelector('img');
  this.promoHeading = this.promo.querySelector('span');
  this.promoDesc = this.promo.querySelector('p');
  this.firstImage = this.querySelector('.mega-menu__image').getAttribute('src');

  this.links = this.querySelectorAll('.js-mega-menu__link');

  this.preloadImages();

  this.links.forEach(link => {
    link.addEventListener('mouseover', () => {
      const image = link.getAttribute('data-image');
      const title = link.getAttribute('data-title');
      const desc = link.getAttribute('data-desc');

      if (image) {
        this.promoImage.setAttribute('src', image);
      } else {
        this.promoImage.setAttribute('src', this.firstImage);
      }

      this.promoHeading.textContent = title;
      this.promoDesc.innerText = desc;
    });
  });
}

preloadImages() {
  this.links.forEach(link => {
    const src = link.getAttribute('data-image');
    if (src) {
      const img = new Image();
      img.src = src;
    }
  });
}
  }

  // Register component
  customElements.define('mega-menu', MegaMenu);
  } catch(e) { console.error(e); }
})();

})();
